<nav>
<a href="https://www.gov.co/" target="_blank" title="Ir al portal GOV.CO" aria-label="Portal del Estado Colombiano - GOV.CO"></a>
  <div><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-category" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ffffff" fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M4 4h6v6h-6z" />
    <path d="M14 4h6v6h-6z" />
    <path d="M4 14h6v6h-6z" />
    <path d="M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
  </svg></div>
</nav>
